export default "__VITE_ASSET__3bc2ddb6__"